exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".release-row{margin-top:10px;margin-bottom:10px;text-transform:uppercase}.purchase-button.btn-success{background-color:#ff5722;border-color:#ff5722;color:#000}.purchase-button.btn-success:hover{background-color:#ff440b;border-color:#ff440b}.card-text{padding-top:20px}.genre-badges{margin-bottom:10px}.release-date{color:grey}.genre-badges .badge{font-size:100%}#player{max-width:100%!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-190ebaef","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Releases.vue
// module id = 396
// module chunks = 0